import React, { useState } from 'react';
import { useMemoService } from '../../../sdk/MemoServiceClient';
import { Error } from '@app/shared';
import { useGlobalContext } from '../../../GlobalContextProvider';
import { useMemoCategories } from '@app/sdk';

export function AddEditMemo({ accountId, onMemoAdded }: { accountId: string; onMemoAdded: () => void }) {
    const [note, setNote] = useState<string>(undefined);
    const [categoryCode, setCategoryCode] = useState<string>(undefined);
    const [channel, setChannel] = useState<string>(undefined);
    const [createdBy, setCreatedBy] = useState<string>(undefined);
    const { data: memoCategories } = useMemoCategories(false);
    const { tenantId } = useGlobalContext();
    const memoService = useMemoService(tenantId);
    const [error, setError] = useState<string | undefined>(undefined);
    const [submitting, setSubmitting] = useState<boolean>(false);

    async function onCreateMemo(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        setSubmitting(true);
        try {

            let headers = {};
            if (channel) {
                headers = { 'context-channel': channel };
            }

            if (createdBy) {
                headers = { 'context-sub': createdBy, ...headers };
            }

            await memoService.addAccountMemo(accountId, { note: note, categoryCode: getCode() }, headers);
            onMemoAdded();
            setNote(undefined);
            setCategoryCode("Please Select");
            setSubmitting(false);
        } catch (e) {
            setSubmitting(false);
            setError(e);
        }
    }
    function getCode() {
        if (categoryCode === "Please Select") {
            return null;
        }

        return categoryCode;
    }

    function createSelectItems() {
        let items = [];
        let data = memoCategories ? memoCategories.categories : [];

        if (data.length === 0)
            return [];

        for (let i = 0; i < data.length; i++) {
            items.push(<option key={data[i].id} value={data[i].code}>{data[i].code}</option>);
        }
        items.unshift(<option key="Please select" value="Please Select">Please Select</option>)
        return items;
    }

    return (
        <form className="ui form" onSubmit={(e) => onCreateMemo(e)}>
            <Error error={error} />
            <div className="field">
                <div className="ui labeled input">
                    <div className="ui label">Note</div>
                    <input
                        required
                        type="text"
                        value={note || ''}
                        onChange={(e) => setNote(e.target.value)}
                        disabled={submitting}
                    />
                </div>
            </div>
            <div className="field">
                <div className="ui labeled input">
                    <div className="ui label">Category Code</div>
                    <select onChange={(e) => setCategoryCode(e.target.value)}  >
                        {createSelectItems()}
                    </select>
                </div>
            </div>
            <div className="field">
                <div className="ui labeled input">
                    <div className="ui label">Channel</div>
                    <input
                        type="text"
                        value={channel || ''}
                        onChange={(e) => setChannel(e.target.value)}
                        disabled={submitting}
                    />
                </div>
            </div>
            <div className="field">
                <div className="ui labeled input">
                    <div className="ui label">Created By</div>
                    <input
                        type="text"
                        value={createdBy || ''}
                        onChange={(e) => setCreatedBy(e.target.value)}
                        disabled={submitting}
                    />
                </div>
            </div>
            <button className={`ui button ${submitting && 'loading'}`} type="submit">
                <span>Add Memo</span>
            </button>
        </form>
    );
}
